/** Shared CPU normal generation; no renderer state. */
export const smoothNormals = (pos: ArrayLike<number>, idx: ArrayLike<number>): Float32Array => {
  const n = new Float32Array(pos.length);
  for (let t = 0; t < idx.length; t += 3) {
    const a = idx[t], b = idx[t + 1], c = idx[t + 2];
    const ux = pos[b * 3] - pos[a * 3], uy = pos[b * 3 + 1] - pos[a * 3 + 1], uz = pos[b * 3 + 2] - pos[a * 3 + 2];
    const vx = pos[c * 3] - pos[a * 3], vy = pos[c * 3 + 1] - pos[a * 3 + 1], vz = pos[c * 3 + 2] - pos[a * 3 + 2];
    const nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx;
    for (const v of [a, b, c]) { n[v * 3] += nx; n[v * 3 + 1] += ny; n[v * 3 + 2] += nz; }
  }
  for (let i = 0; i < n.length; i += 3) { const l = Math.hypot(n[i], n[i + 1], n[i + 2]) || 1; n[i] /= l; n[i + 1] /= l; n[i + 2] /= l; }
  return n;
};

export function weldedSmoothNormals(pos: Float32Array, I: Uint32Array): Float32Array {
  const vc = pos.length / 3;
  const key = (i: number) => `${Math.round(pos[i * 3] * 2e4)},${Math.round(pos[i * 3 + 1] * 2e4)},${Math.round(pos[i * 3 + 2] * 2e4)}`;
  const weld = new Map<string, number>(); const group = new Int32Array(vc);
  for (let i = 0; i < vc; i++) { const k = key(i); let g = weld.get(k); if (g === undefined) { g = weld.size; weld.set(k, g); } group[i] = g; }
  const acc = new Float32Array(weld.size * 3);
  for (let t = 0; t < I.length; t += 3) {
    const a = I[t], b = I[t + 1], c = I[t + 2];
    const ux = pos[b * 3] - pos[a * 3], uy = pos[b * 3 + 1] - pos[a * 3 + 1], uz = pos[b * 3 + 2] - pos[a * 3 + 2];
    const vx = pos[c * 3] - pos[a * 3], vy = pos[c * 3 + 1] - pos[a * 3 + 1], vz = pos[c * 3 + 2] - pos[a * 3 + 2];
    const nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx;
    for (const v of [a, b, c]) { const g = group[v]; acc[g * 3] += nx; acc[g * 3 + 1] += ny; acc[g * 3 + 2] += nz; }
  }
  const smoothN = new Float32Array(vc * 3);
  for (let i = 0; i < vc; i++) { const g = group[i]; const l = Math.hypot(acc[g * 3], acc[g * 3 + 1], acc[g * 3 + 2]) || 1; smoothN[i * 3] = acc[g * 3] / l; smoothN[i * 3 + 1] = acc[g * 3 + 1] / l; smoothN[i * 3 + 2] = acc[g * 3 + 2] / l; }
  return smoothN;
}
